module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration002.14587dab.webp";